import type { TPractice, TPublicPractice, TGPPractice, IPracticeFilters } from "./types";
import {
  createPathParamCRUD,
  getAllPathParam,
  getPaginatedFilteredPathParam,
  type NoPathParams,
} from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "practice";
const PUBLIC_SLUG = "patient/public/practice";
const SEARCH_SLUG = `${SLUG}/search`;
const PUBLIC_SEARCH_SLUG = `${PUBLIC_SLUG}/search`;

type TPracticeRelatedPathParams = { practice_id?: string };

export default createService(SLUG, {
  ...createPathParamCRUD<TPractice, NoPathParams, IPracticeFilters>(SLUG, SEARCH_SLUG),

  getAllOrtho: getAllPathParam<TPractice, NoPathParams, IPracticeFilters>(
    `${SLUG}/ortho-offices`,
    `${SLUG}/ortho-offices/search`
  ),
  getAllGP: getAllPathParam<TGPPractice, NoPathParams, IPracticeFilters>(
    `${SLUG}/gp-offices`,
    `${SLUG}/gp-offices/search`
  ),

  getPaginatedOrtho: getPaginatedFilteredPathParam<TPractice, NoPathParams, IPracticeFilters>(
    `${SLUG}/ortho-offices`,
    `${SEARCH_SLUG}/ortho-offices`
  ),
  getPaginatedGP: getPaginatedFilteredPathParam<TGPPractice, NoPathParams, IPracticeFilters>(
    `${SLUG}/gp-offices`,
    `${SEARCH_SLUG}/gp-offices`
  ),

  getRelatedPractices: getAllPathParam<TPractice, TPracticeRelatedPathParams>(
    `${SLUG}/{practice_id}/related/`,
    "search/"
  ),

  getMyPractices: getAllPathParam<TPractice>(`${SLUG}/me`),

  public: createPathParamCRUD<TPublicPractice, NoPathParams, IPracticeFilters>(
    PUBLIC_SLUG,
    PUBLIC_SEARCH_SLUG
  ),
});
